window.tabbing = window.tabbing || {};
$(function () {
    'use strict';

    var cKey;
    var cKeyShifted;
    var minicartError = '.mini-cart.fastspring-error';
    var errorContactBtn = minicartError + ' a';
    var miniCartMenuBtn = '.fs-cart-link';
    var miniCartcheckoutBtn = '.mini-cart-checkout';
    var menuAccountbtn = '.signin-link';
    var enterKeyCode = 13;

    var tabigation = function ( tabFoward, tabBack ) {
        if (cKey === 9) {
            if (tabFoward !== null && !cKeyShifted) {
                if (tabFoward.is(':visible')) {
                    tabFoward.focus();
                }
            }
            if (tabBack !== null && cKeyShifted) {
                if (tabBack.is(':visible')) {
                    tabBack.focus();
                }
            }
        }
        cKey = 0;
        cKeyShifted = false;
    };

    var setTabbingOrder = function ( element ) {
        if ( element.attr('tabindex') !== '1200' ) {
            element.attr('tabindex', '1200');
        }
    };

    var determineElement = function () {
        var tabElement = $(miniCartcheckoutBtn);
        if ($(minicartError).is(':visible')) {
            tabElement = $(errorContactBtn);
        }
        return tabElement;
    };

    $(document).on('keydown', miniCartMenuBtn + ',' + menuAccountbtn + ',' + miniCartcheckoutBtn + ',' + errorContactBtn, function (e) {
        cKey = e.keyCode;
        cKeyShifted = e.shiftKey;
    });

    $(miniCartMenuBtn).on('focusout', function (event) {
        var tabElement = determineElement();
        setTabbingOrder(tabElement);
        tabigation(tabElement, null);
    });

    $(menuAccountbtn).on('focusout', function (event) {
        var tabElement = determineElement();
        setTabbingOrder(tabElement);
        tabigation(null, tabElement);
    });

    $(document).on('keydown', miniCartcheckoutBtn, function (e) {
        if ( e.keyCode !== enterKeyCode) {
            e.preventDefault();
            tabigation($(menuAccountbtn), $(miniCartMenuBtn));
        }
    });

    if ($(miniCartcheckoutBtn) ) {
        setTabbingOrder($(miniCartcheckoutBtn));
    }

    $(document).on('keydown', errorContactBtn, function (e) {
        if ( e.keyCode !== enterKeyCode) {
            e.preventDefault();
            tabigation($(menuAccountbtn), $(miniCartMenuBtn));
        }
    });

    if ($(errorContactBtn)) {
        setTabbingOrder($(miniCartcheckoutBtn));
    }
});